import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-694b8f86")

_pushScopeId("data-v-694b8f86")
const _hoisted_1 = { class: "tactics" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", null, "优秀组合展示", -1)
const _hoisted_3 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_tactics_item = _resolveComponent("tactics-item")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tacticsItems, (item) => {
        return (_openBlock(), _createBlock(_component_tactics_item, {
          class: {'tactics_item': true, 'myself': _ctx.isMyself(item.strategy_id)},
          item: item,
          key: item.strategy_id,
          onClick: ($event: any) => (_ctx.goDetail(item))
        }, null, 8, ["class", "item", "onClick"]))
      }), 128))
    ])
  ]))
})